import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ContactPopup from './ContactPopup';

const Navigation: React.FC = () => {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsContactPopupOpen(true);
  };

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const handleServicesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#services');
    }
  };

  return (
    <>
      <nav className="fixed top-0 right-0 p-4 md:p-8 z-50">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center backdrop-blur-md bg-gray-950/75 rounded-full border border-white/12 shadow-[0_2px_20px_rgba(0,0,0,0.35)] overflow-hidden"
        >
          <a
            href="/"
            onClick={handleHomeClick}
            className="text-xs md:text-sm text-white hover:text-gold-400 hover:bg-white/8 transition-colors duration-300 tracking-wider whitespace-nowrap px-4 md:px-6 py-2 md:py-3"
          >
            Home
          </a>

          <div className="w-px h-5 bg-white/15 flex-shrink-0" />

          <Link
            to="/about"
            className="text-xs md:text-sm text-white hover:text-gold-400 hover:bg-white/8 transition-colors duration-300 tracking-wider whitespace-nowrap px-4 md:px-6 py-2 md:py-3"
          >
            About
          </Link>

          <div className="w-px h-5 bg-white/15 flex-shrink-0" />

          <a
            href="#services"
            onClick={handleServicesClick}
            className="text-xs md:text-sm text-white hover:text-gold-400 hover:bg-white/8 transition-colors duration-300 tracking-wider whitespace-nowrap px-4 md:px-6 py-2 md:py-3"
          >
            Services
          </a>

          <div className="w-px h-5 bg-white/15 flex-shrink-0" />

          <a
            href="#contact"
            onClick={handleContactClick}
            className="text-xs md:text-sm text-white hover:text-gold-400 hover:bg-white/8 transition-colors duration-300 tracking-wider whitespace-nowrap px-4 md:px-6 py-2 md:py-3"
          >
            Contact
          </a>
        </motion.div>
      </nav>

      <ContactPopup 
        isOpen={isContactPopupOpen} 
        onClose={() => setIsContactPopupOpen(false)} 
      />
    </>
  );
};

export default Navigation;